import { jsx as _jsx } from "react/jsx-runtime";
import BaseContentLoader from "react-content-loader";
const Skeleton = (props) => {
    const { children, height, width } = props;
    return (_jsx("div", { "data-testid": "skeleton", children: _jsx(BaseContentLoader, { style: { width, height }, ...props, speed: 2, children: children }) }));
};
export default Skeleton;
